"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    EN: {
        January: 0,
        February: 1,
        March: 2,
        April: 3,
        May: 4,
        June: 5,
        July: 6,
        August: 7,
        September: 8,
        October: 9,
        November: 10,
        December: 11,
    },
    AR: {
        يناير: 0,
        فبراير: 1,
        مارس: 2,
        إبريل: 3,
        مايو: 4,
        يونيو: 5,
        يوليو: 6,
        أغسطس: 7,
        سبتمير: 8,
        أكتوبر: 9,
        نوفمبر: 10,
        ديسمبر: 11,
    },
};
